var React = require('react');

function IconMedium (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Medium"),React.createElement("g",{"fillRule":"nonzero","fill":"none","key":1},[React.createElement("rect",{"fill":"#002B41","width":"29","height":"29","rx":"3","key":0}),React.createElement("path",{"d":"M8.18 10.821a.589.589 0 00-.21-.511L6.423 8.549v-.263h4.804l3.714 7.694 3.265-7.694h4.58v.263l-1.323 1.198a.356.356 0 00-.147.35v8.805a.356.356 0 00.147.351l1.292 1.198v.263h-6.499v-.263l1.339-1.227c.131-.124.131-.161.131-.351v-7.117l-3.721 8.93h-.503l-4.332-8.93v5.984a.797.797 0 00.24.687l1.74 1.995v.263H6.214v-.263l1.741-1.995a.768.768 0 00.224-.687v-6.919z","fill":"#FFF","key":1})])]);
}

IconMedium.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29"};

module.exports = IconMedium;

IconMedium.default = IconMedium;
